"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CtaCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _hexRgb = _interopRequireDefault(require("hex-rgb"));
var _Title = require("../../Elements/Title/Title");
var _Text = require("../../Elements/Text/Text");
var _Button = require("../../Elements/Button/Button");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for CTA
 */
const CtaCard = ({
  isTransparent,
  hasShadow,
  backgroundColor,
  content,
  image,
  onClick
}) => {
  const defaultBackground = '#fff';

  // confirm string is a valid hex value
  const bgColorCheck = /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(backgroundColor || defaultBackground);

  // convert hex to rgb color and apply transparency, else default to white
  const bgColor = bgColorCheck ? (0, _hexRgb.default)(backgroundColor, {
    format: 'css',
    alpha: isTransparent ? 0.8 : 1
  }) : defaultBackground;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: ['ccl__cta_card', hasShadow ? 'ccl__cta_card--border' : ''].join(' '),
    style: backgroundColor && {
      backgroundColor: bgColor
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
      content: content.title,
      tag: "h1"
    }), Object.entries(image).length !== 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("figure", {
      className: `ccl__cta_card__image ccl__cta_card__image--${image.shape}`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "image",
        src: image.src,
        alt: image.alt
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
      content: content.text
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      variant: "digital-primary",
      icon: "chevron-right",
      text: content.btnText,
      onClick: onClick
    })]
  });
};
exports.CtaCard = CtaCard;
CtaCard.defaultProps = {
  isTransparent: false,
  hasShadow: false,
  backgroundColor: '#ffffff',
  onClick: undefined,
  image: {}
};